import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { ProcurementProjectLotStateInfoComponent } from './component/procurementProjectLotStateInfo.component';
import { ContractsModule } from '../../dossiers/contracts/contracts.module';



@NgModule({
  declarations: [ProcurementProjectLotStateInfoComponent],
  imports: [
    CommonModule,
    FormPlycaModule,
    ContractsModule
  ],
  exports: [ProcurementProjectLotStateInfoComponent]
})
export class ProcurementProjectLotStateInfoModule {

}